module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=IN - India.5b3702ba.svg";